import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_issues1z1skb5sgeygq as get_issues,
  MutableValidated2ognu5vxf17ur as MutableValidated,
  lensi9s8q1zaykbw as lens,
  lens2dr2mfn274h1a as lens_0,
} from '../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { InvalidSemantic_getInstance19jq406epp0mv as InvalidSemantic_getInstance } from '../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { validates376qnagkfv6he as validates } from '../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import {
  Warning3n5ye4cehejrw as Warning,
  Invalid2lchzzxcoxbzy as Invalid,
} from '../../../../reactive/com/lightningkite/reactive/lensing/validation/IssueNode.mjs';
import {
  assert3pektuc8qw5gc as assert,
  assertNotBlank3rcqh0n27fq5q as assertNotBlank,
} from '../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { MutableRememberyv35kz5kmml7 as MutableRemember } from '../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import {
  _EmailAddress___get_raw__impl__6ose21hsaqj8b5ou10 as _EmailAddress___get_raw__impl__6ose2,
  _PhoneNumber___get_raw__impl__gc2pmp2lry17e31ba5a as _PhoneNumber___get_raw__impl__gc2pmp,
  toPhoneNumber24bmj59aego07 as toPhoneNumber,
  PhoneNumber2x98iurnwvnj9 as PhoneNumber,
  toEmailAddress2ffkb20dbp5nk as toEmailAddress,
  EmailAddress1n0o8cqqfp9qz as EmailAddress,
} from '../../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  ValidatedSetLens3tjmcbmmtgp0c as ValidatedSetLens,
  ValidatedModifyLensxnr6y4izl6zn as ValidatedModifyLens,
} from '../../../../reactive/com/lightningkite/reactive/lensing/validation/validationLenses.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  MutableReactive2qdhhyljdknhy as MutableReactive,
  Reactive1jy75v4li6ldv as Reactive,
  addAndRunListener8g331b1wn43q as addAndRunListener,
} from '../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { SharedUtils_getInstanceggolgle4lzs6 as SharedUtils_getInstance } from '../../../../crowpay-shared/com/crowpay/sharedUtils.mjs';
import { takeLast2r8kr8e6g6hi7 as takeLast } from '../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import {
  set_value1vvx5pkb20ebv as set_value,
  onNextSuccessppx6mg1nws5i as onNextSuccess,
} from '../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { BaseListenable1u3g4s45l82o6 as BaseListenable } from '../../../../reactive/com/lightningkite/reactive/core/abstracts.mjs';
import { ReactiveState__getOrNull_impl_1asnfp2wx27g6rqhoxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function validate(_this__u8e3s4, validates, validatesWhen) {
  var tmp;
  if (validatesWhen === VOID) {
    tmp = validate$lambda;
  } else {
    tmp = validatesWhen;
  }
  validatesWhen = tmp;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.bbb_1;
  var tmp_0 = _this__u8e3s4;
  tmp_0.bbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    dynamicTheme(_this__u8e3s4, ($this$dynamicTheme) => {
      var tmp;
      var tmp_0;
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      if (validatesWhen($this$dynamicTheme)) {
        var tmp0 = validates;
        var tmp$ret$3;
        $l$block: {
          // Inline function 'kotlin.collections.any' call
          var inductionVariable = 0;
          var last = tmp0.length;
          while (inductionVariable < last) {
            var element = tmp0[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!$this$dynamicTheme.baj(get_issues(element)).i1()) {
              tmp$ret$3 = true;
              break $l$block;
            }
          }
          tmp$ret$3 = false;
        }
        tmp_0 = tmp$ret$3;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = InvalidSemantic_getInstance();
      } else {
        tmp = null;
      }
      return tmp;
    });
    return Unit_instance;
  };
  return Companion_getInstance();
}
function validate_0(_this__u8e3s4, item, validatesWhen) {
  var tmp;
  if (validatesWhen === VOID) {
    tmp = validate$lambda_0;
  } else {
    tmp = validatesWhen;
  }
  validatesWhen = tmp;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.bbb_1;
  var tmp_0 = _this__u8e3s4;
  tmp_0.bbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    validates(_this__u8e3s4, [item], validatesWhen);
    return Unit_instance;
  };
  return Companion_getInstance();
}
function validate_1(_this__u8e3s4, item, validatesWhen) {
  var tmp;
  if (validatesWhen === VOID) {
    tmp = validate$lambda_1;
  } else {
    tmp = validatesWhen;
  }
  validatesWhen = tmp;
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.bbb_1;
  var tmp_0 = _this__u8e3s4;
  tmp_0.bbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    dynamicTheme(_this__u8e3s4, ($this$dynamicTheme) => {
      var tmp;
      var tmp_0;
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      if (validatesWhen($this$dynamicTheme)) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_0 = !$this$dynamicTheme.baj(item.pat_1).i1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = InvalidSemantic_getInstance();
      } else {
        tmp = null;
      }
      return tmp;
    });
    return Unit_instance;
  };
  return Companion_getInstance();
}
function validateReactive(_this__u8e3s4, predicate) {
  _this__u8e3s4.sat(($this$reactiveReport) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp0_safe_receiver = predicate($this$reactiveReport);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new (Warning())(tmp0_safe_receiver);
    }
    return tmp;
  });
}
function assertReactive(_this__u8e3s4, summary, description, predicate) {
  description = description === VOID ? summary : description;
  _this__u8e3s4.sat(($this$reactiveReport) => {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    if (predicate($this$reactiveReport)) {
      tmp = null;
    } else {
      tmp = new (Warning())(summary, description);
    }
    return tmp;
  });
}
function branch(_this__u8e3s4) {
  return new (branch$1())(_this__u8e3s4);
}
function assertValidEmail(_this__u8e3s4) {
  return assert(_this__u8e3s4, 'Must be a valid email', VOID, VOID, assertValidEmail$lambda);
}
function assertValidPhoneNumber(_this__u8e3s4) {
  return assert(_this__u8e3s4, 'Must be a valid US phone number', VOID, VOID, assertValidPhoneNumber$lambda);
}
function assertValidPhoneNumber_0(_this__u8e3s4, getStr) {
  var tmp;
  if (getStr === VOID) {
    tmp = assertValidPhoneNumber$lambda_0;
  } else {
    tmp = getStr;
  }
  getStr = tmp;
  var buffer = MutableRemember().rak(false, VOID, VOID, VOID, ($this$MutableRemember) => getStr($this$MutableRemember.baj(_this__u8e3s4)));
  return new (assertValidPhoneNumber$5())(buffer, _this__u8e3s4);
}
function assertValidEmail_0(_this__u8e3s4) {
  var buffer = MutableRemember().rak(false, VOID, VOID, VOID, ($this$MutableRemember) => _EmailAddress___get_raw__impl__6ose2($this$MutableRemember.baj(_this__u8e3s4).c3n_1));
  return assertValidEmail$3().ug7(_this__u8e3s4, buffer);
}
function assertNotBlankNamed(_this__u8e3s4, name, summary) {
  summary = summary === VOID ? 'Cannot be blank' : summary;
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = summary.toLowerCase();
  return assertNotBlank(_this__u8e3s4, summary, name + ' ' + tmp$ret$1);
}
function validate$lambda(_this__u8e3s4) {
  return true;
}
function validate$lambda_0(_this__u8e3s4) {
  return true;
}
function validate$lambda_1(_this__u8e3s4) {
  return true;
}
function *_generator_set__cb7isu($this, value, $completion) {
  var tmp = $this.vg7_1.gah(value, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var branch$1Class;
function branch$1() {
  if (branch$1Class === VOID) {
    class $ {
      constructor($this_branch) {
        this.vg7_1 = $this_branch;
        this.wg7_1 = $this_branch.vat().tat();
      }
      vat() {
        return this.wg7_1;
      }
      tak(get, set) {
        return ValidatedSetLens().dau(this, get, set);
      }
      bak(get, modify) {
        return ValidatedModifyLens().lau(this, get, modify);
      }
      qah() {
        return this.vg7_1.qah();
      }
      tah(listener) {
        return this.vg7_1.tah(listener);
      }
      iaj() {
        return this.vg7_1.iaj();
      }
      gah(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_set__cb7isu.bind(VOID, this, value), $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [MutableValidated(), MutableReactive()], [1]);
    branch$1Class = $;
  }
  return branch$1Class;
}
function assertValidEmail$lambda(it) {
  // Inline function 'kotlin.text.matches' call
  return SharedUtils_getInstance().e9s_1.rh(it);
}
function assertValidPhoneNumber$lambda(it) {
  // Inline function 'kotlin.text.matches' call
  return SharedUtils_getInstance().f9s_1.rh(it);
}
function assertValidPhoneNumber$lambda_0(it) {
  return takeLast(_PhoneNumber___get_raw__impl__gc2pmp(it.h3n_1), 10);
}
function *_generator_set__cb7isu_0($this, value, $completion) {
  try {
    var number = toPhoneNumber(value);
    $this.yg7_1.rat(null);
    var tmp = $this.ag8_1.gah(new (PhoneNumber())(number), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    $this.zg7_1.f52();
  } catch ($p) {
    if ($p instanceof IllegalArgumentException()) {
      var _unused_var__etf5q3 = $p;
      $this.yg7_1.rat(new (Invalid())('Not a valid phone number'));
      set_value($this.zg7_1, value);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
var assertValidPhoneNumber$5Class;
function assertValidPhoneNumber$5() {
  if (assertValidPhoneNumber$5Class === VOID) {
    class $ {
      constructor($buffer, $this_assertValidPhoneNumber) {
        this.zg7_1 = $buffer;
        this.ag8_1 = $this_assertValidPhoneNumber;
        this.xg7_1 = $buffer;
        this.yg7_1 = $this_assertValidPhoneNumber.vat().tat();
        onNextSuccess($this_assertValidPhoneNumber, (it) => {
          var tmp;
          try {
            toPhoneNumber(_PhoneNumber___get_raw__impl__gc2pmp(it.h3n_1));
            this.yg7_1.rat(null);
            tmp = Unit_instance;
          } catch ($p) {
            var tmp_0;
            if ($p instanceof IllegalArgumentException()) {
              var _unused_var__etf5q3 = $p;
              this.yg7_1.rat(new (Invalid())('Not a valid phone number'));
              tmp_0 = Unit_instance;
            } else {
              throw $p;
            }
            tmp = tmp_0;
          }
          return Unit_instance;
        });
      }
      vat() {
        return this.yg7_1;
      }
      bg8(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_set__cb7isu_0.bind(VOID, this, value), $completion);
      }
      gah(value, $completion) {
        return this.bg8((!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE(), $completion);
      }
      cg8() {
        return this.xg7_1.qah();
      }
      qah() {
        return this.cg8();
      }
      tah(listener) {
        return this.xg7_1.tah(listener);
      }
      iaj() {
        return this.xg7_1.iaj();
      }
    }
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    initMetadataForClass($, VOID, VOID, VOID, [MutableValidated(), Reactive()], [1]);
    assertValidPhoneNumber$5Class = $;
  }
  return assertValidPhoneNumber$5Class;
}
function *_generator_set__cb7isu_1($this, value, $completion) {
  try {
    var email = toEmailAddress(value);
    $this.pg7_1.rat(null);
    var tmp = $this.sg7_1.gah(new (EmailAddress())(email), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    $this.tg7_1.f52();
  } catch ($p) {
    if ($p instanceof IllegalArgumentException()) {
      var _unused_var__etf5q3 = $p;
      $this.pg7_1.rat(new (Invalid())('Not a valid email'));
      set_value($this.tg7_1, value);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
var assertValidEmail$3Class;
function assertValidEmail$3() {
  if (assertValidEmail$3Class === VOID) {
    class $ extends BaseListenable() {
      static ug7($this_assertValidEmail, $buffer, $box) {
        if ($box === VOID)
          $box = {};
        $box.sg7_1 = $this_assertValidEmail;
        $box.tg7_1 = $buffer;
        var $this = this.sam($box);
        $this.pg7_1 = $this_assertValidEmail.vat().tat();
        $this.qg7_1 = null;
        $this.rg7_1 = null;
        return $this;
      }
      vat() {
        return this.pg7_1;
      }
      bg8(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_set__cb7isu_1.bind(VOID, this, value), $completion);
      }
      gah(value, $completion) {
        return this.bg8((!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE(), $completion);
      }
      cg8() {
        return this.tg7_1.qah();
      }
      qah() {
        return this.cg8();
      }
      ial() {
        var tmp = this;
        tmp.qg7_1 = addAndRunListener(this.sg7_1, () => {
          var tmp = ReactiveState__getOrNull_impl_1asnfp(this.sg7_1.qah());
          var tmp0_elvis_lhs = tmp == null ? null : tmp.c3n_1;
          var tmp_0;
          var tmp_1 = tmp0_elvis_lhs;
          if ((tmp_1 == null ? null : new (EmailAddress())(tmp_1)) == null) {
            return Unit_instance;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var it = tmp_0;
          var tmp_2;
          try {
            toEmailAddress(_EmailAddress___get_raw__impl__6ose2(it));
            this.pg7_1.rat(null);
            tmp_2 = Unit_instance;
          } catch ($p) {
            var tmp_3;
            if ($p instanceof IllegalArgumentException()) {
              var _unused_var__etf5q3 = $p;
              this.pg7_1.rat(new (Invalid())('Not a valid email'));
              tmp_3 = Unit_instance;
            } else {
              throw $p;
            }
            tmp_2 = tmp_3;
          }
          return Unit_instance;
        });
        var tmp_0 = this;
        tmp_0.rg7_1 = this.tg7_1.tah(() => {
          this.kal();
          return Unit_instance;
        });
      }
      jal() {
        var tmp0_safe_receiver = this.qg7_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        var tmp1_safe_receiver = this.rg7_1;
        if (tmp1_safe_receiver == null)
          null;
        else
          tmp1_safe_receiver();
      }
    }
    protoOf($).tak = lens;
    protoOf($).bak = lens_0;
    initMetadataForClass($, VOID, VOID, VOID, [MutableValidated(), Reactive(), BaseListenable()], [1]);
    assertValidEmail$3Class = $;
  }
  return assertValidEmail$3Class;
}
//region block: exports
export {
  assertNotBlankNamed as assertNotBlankNamed365y7czhf0np3,
  assertReactive as assertReactive1648n57bmw8d1,
  assertValidEmail as assertValidEmail3vrj63qp73iex,
  assertValidEmail_0 as assertValidEmail3utsnuo6xdy4w,
  assertValidPhoneNumber_0 as assertValidPhoneNumber13ya35cr3f72y,
  assertValidPhoneNumber as assertValidPhoneNumber18rbry4lwjr66,
  branch as branchij6ujhcuk22z,
  validateReactive as validateReactive1mjr7u7b9jd4s,
  validate_0 as validategsg6go7eyi9d,
  validate_1 as validatecngbak7otryq,
  validate as validate1c6autp3a2bus,
};
//endregion

//# sourceMappingURL=validation.mjs.map
